import StandardError from '@/modules/errors/Standard'

class InvalidCredentialsError extends StandardError {
  constructor(message = 'Invalid Credentials', status = 400, body = {}) {
    super(message)
    this.status = status
    this.body = body
  }
}
export default InvalidCredentialsError
